/* ------------------------------------------------------------------
   Smarte Suche (Luxusbetten24): versteht Tippfehler, Synonyme und Absicht (Kategorie, Farbe, Größe, Bezug)
   und sucht im Produktindex (cx-search-index.json, täglich neu) statt nur in Shopifys Wortsuche.

   - Normalisierung: Kleinschreibung, Umlaute (ä→ae …), Maße „140 x 200“ → „140x200“
   - Tippfehler: Wortschatz aus allen Produkttiteln/Kategorien; nächstes Wort per Damerau-Levenshtein (≤1 bzw. ≤2)
   - Zusammensetzungen: „schlafsofa“ → „schlaf“ + „sofa“, wenn beide Teile im Wortschatz sind
   - Synonyme: eingebaut (couch → sofa, bubble → bouclé/teddy …) + Theme-Einstellung „couch=sofa, …“
   - Absicht: Kategorie-Wörter, Farbwörter (zeigen das passende Variantenbild), Größen (140x200), Bezug (Samt, Cord …)
   - Rangfolge: Treffer je Suchwort (Titel > Kategorie > Bezug/Farbe/Größe), dann Verkäufe und Bewertung

   Einbau: Such-Schublade (sections/search-drawer.liquid, <div data-cxs ...>) und Suchergebnisseite
   (sections/main-search.liquid, <div data-cxs-page ...>: „Passende Treffer“ über dem Shopify-Raster).
   ------------------------------------------------------------------ */
(function () {
  'use strict';
  // Ältere Produktbilder liegen unter /products/, neuere Uploads unter /files/ – der Index speichert beides ohne CDN-Präfix.
  var CDN = 'https://cdn.shopify.com/s/files/1/0416/8197/7495/';

  // ---------- Normalisierung ----------
  function fold(s) {
    return String(s == null ? '' : s).toLowerCase()
      .replace(/(\d{2,3})\s*(?:x|×|\*)\s*(\d{2,3})\s*(?:cm)?/g, '$1x$2')
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[éèêë]/g, 'e').replace(/[àâá]/g, 'a').replace(/[ôó]/g, 'o').replace(/[ûú]/g, 'u').replace(/ç/g, 'c')
      .replace(/[^a-z0-9x]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function tokens(s) { return fold(s).split(' ').filter(Boolean); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) {
    if (n == null) return '';
    var v = Math.round(n * 100) / 100;
    var s = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return s.replace(/,00$/, '') + ' €';
  }
  function imgUrl(file, w) { return file ? CDN + (file.indexOf('products/') === 0 ? '' : 'files/') + file + '?width=' + (w || 480) : ''; }
  function uniq(arr) { var o = {}; return arr.filter(function (x) { if (o[x]) return false; o[x] = 1; return true; }); }

  // Damerau-Levenshtein (optimal string alignment), früh abbrechen über max
  function dist(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var prev2 = null, prev = [], cur, i, j;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur = [i]; var rowMin = i;
      for (j = 1; j <= lb; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + cost);
        cur[j] = v; if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[lb];
  }

  // ---------- Wissen: Synonyme, Farben, Bezüge, Kategorien ----------
  // Jede Zeile: Suchwort → Wörter, die stattdessen/auch gesucht werden (Titel, Kategorie, Bezug). Alles gefaltet (ae/oe/ue).
  var SYNONYMS = {
    couch: ['sofa'], kanapee: ['sofa'], sofas: ['sofa'], couchgarnitur: ['sofa'], polstergarnitur: ['sofa'], sitzgarnitur: ['sofa'],
    wohnlandschaft: ['sofa', 'u', 'xxl'], bigsofa: ['sofa', 'xxl', '3-sitzer'], big: ['xxl'], megasofa: ['sofa', 'xxl'],
    schlafsofa: ['sofa', 'schlaffunktion', 'schlaf', 'bettfunktion'], schlafcouch: ['sofa', 'schlaffunktion', 'schlaf', 'bettfunktion'],
    bettsofa: ['sofa', 'schlaffunktion', 'schlaf', 'bettfunktion'], bettcouch: ['sofa', 'schlaffunktion', 'schlaf'],
    schlaffunktion: ['schlaffunktion', 'schlaf', 'bettfunktion'], ausziehbar: ['schlaffunktion', 'schlaf', 'ausziehbar'],
    eckcouch: ['ecksofa'], ecksofa: ['ecksofa', 'sofa'], ottomane: ['ecksofa', 'ottomane'], recamiere: ['ecksofa', 'ottomane'], lform: ['ecksofa', 'l'],
    usofa: ['sofa', 'u'], uform: ['sofa', 'u'], zweisitzer: ['2-sitzer', '2'], dreisitzer: ['3-sitzer', '3'], '2er': ['2-sitzer'], '3er': ['3-sitzer'],
    bubble: ['bubble', 'boucle', 'teddy', 'wolken'], bubblebett: ['bett', 'boucle', 'teddy'], bubblesofa: ['sofa', 'bubble', 'boucle', 'teddy'],
    wolke: ['boucle', 'teddy', 'wolken'], wolken: ['boucle', 'teddy', 'wolken'], wolkenbett: ['bett', 'boucle', 'teddy'], wolkensofa: ['sofa', 'boucle', 'teddy'],
    cloud: ['boucle', 'teddy'], puffig: ['boucle', 'teddy'], plueschig: ['teddy', 'boucle'], kuschelig: ['teddy', 'boucle'], teddystoff: ['teddy'], boucle: ['boucle'], bouclee: ['boucle'],
    bett: ['bett', 'betten'], betten: ['bett'], boxspring: ['boxspringbett'], boxspringbetten: ['boxspringbett'], polster: ['polsterbett'], polsterbetten: ['polsterbett'],
    doppelbett: ['bett', '180x200', '160x200'], ehebett: ['bett', '180x200'], kingsize: ['bett', '200x200', '180x200'], queensize: ['bett', '160x200'],
    einzelbett: ['bett', '90x200', '100x200'], jugendbett: ['bett', '90x200', '120x200', 'kinder'], kinderbett: ['kinderbett', 'kinder', 'bett'], babybett: ['kinderbett', 'kinder'],
    hochbett: ['hochbett', 'kinder'], familienbett: ['familien', 'bett', '240x200', '270x200'], xxlbett: ['bett', '240x200'],
    bettgestell: ['bett', 'polsterbett', 'holzbett'], bettrahmen: ['bett', 'polsterbett', 'holzbett'], holzbett: ['holzbett', 'holz', 'bett'], massivholzbett: ['holzbett', 'massiv'],
    bettkasten: ['stauraum', 'bettkasten'], stauraumbett: ['bett', 'stauraum'], stauraum: ['stauraum', 'bettkasten', 'schubladen'], schublade: ['schubladen', 'stauraum'], schubladen: ['schubladen', 'stauraum'],
    kopfteil: ['kopfteil'], tvlift: ['tv', 'lift'], fernseher: ['tv'], elektrisch: ['elektrisch', 'motor'], motor: ['motor', 'elektrisch'], verstellbar: ['elektrisch', 'motor', 'verstellbar'],
    matratze: ['matratze'], matratzen: ['matratze'], topper: ['topper'], lattenrost: ['lattenrost'], lattenroste: ['lattenrost'], bettwaesche: ['bettwaesche'], bettdecke: ['bettdecke', 'decke'], kopfkissen: ['kissen', 'nackenstuetzkissen'],
    nackenkissen: ['nackenstuetzkissen', 'kissen'], kissen: ['kissen', 'zierkissen'], dekokissen: ['zierkissen'], sofakissen: ['zierkissen'], decke: ['decke', 'tagesdecke', 'bettdecke'], plaid: ['decke', 'tagesdecke'],
    schrank: ['schrank', 'kleiderschrank', 'kommode'], schraenke: ['schrank', 'kleiderschrank'], kleiderschraenke: ['kleiderschrank'], kleiderschrank: ['kleiderschrank', 'schrank'], garderobe: ['garderobe', 'wandgarderobe'],
    kommode: ['kommode'], sideboard: ['sideboard', 'kommode', 'lowboard'], lowboard: ['lowboard', 'tv'], tvboard: ['lowboard', 'tv'], tvschrank: ['lowboard', 'tv'], fernsehschrank: ['lowboard', 'tv'], wohnwand: ['wohnwand'],
    regal: ['regal', 'wandregal', 'buecherregal'], regale: ['regal'], buecherregal: ['regal', 'buecherregal'], schuhschrank: ['schuhregal', 'schuhschrank'], schuhregal: ['schuhregal'],
    tisch: ['tisch', 'esstisch', 'couchtisch', 'beistelltisch'], tische: ['tisch'], esstisch: ['esstisch'], esstische: ['esstisch'], esszimmertisch: ['esstisch'], kuechentisch: ['esstisch'], esszimmer: ['esstisch', 'stuhl', 'esszimmer'],
    couchtisch: ['couchtisch'], couchtische: ['couchtisch'], wohnzimmertisch: ['couchtisch'], sofatisch: ['couchtisch', 'beistelltisch'], beistelltisch: ['beistelltisch'], nachttisch: ['nachttisch'], nachtkonsole: ['nachttisch'], nachtschrank: ['nachttisch'],
    konsole: ['konsolentisch', 'konsole'], schreibtisch: ['schreibtisch'], buerotisch: ['schreibtisch'],
    stuhl: ['stuhl', 'stuehle', 'esszimmerstuhl'], stuehle: ['stuhl', 'esszimmerstuhl'], esszimmerstuhl: ['stuhl', 'esszimmerstuhl'], kuechenstuhl: ['stuhl'], buerostuhl: ['buerostuhl', 'stuhl'], barhocker: ['barhocker', 'hocker'], barstuhl: ['barhocker'],
    sessel: ['sessel'], fernsehsessel: ['sessel', 'relax'], relaxsessel: ['sessel', 'relax'], ohrensessel: ['sessel'], loungesessel: ['loungesessel', 'sessel'], haengesessel: ['haengesessel'],
    hocker: ['hocker', 'pouf', 'beistellhocker'], pouf: ['pouf', 'hocker'], sitzbank: ['sitzbank', 'bank'], bank: ['bank', 'sitzbank'], baenke: ['bank', 'sitzbank'],
    liege: ['liege', 'relaxliege', 'sonnenliege'], relaxliege: ['relaxliege', 'liege'], sonnenliege: ['sonnenliege', 'liege'], daybed: ['liege', 'tagesbett'], chaiselongue: ['liege', 'ecksofa'],
    lampe: ['lampe', 'leuchte'], lampen: ['lampe', 'leuchte'], leuchte: ['leuchte', 'lampe'], leuchten: ['leuchte', 'lampe'], deckenlampe: ['pendelleuchte', 'deckenleuchte'], deckenleuchte: ['deckenleuchte', 'pendelleuchte'],
    haengelampe: ['pendelleuchte'], pendellampe: ['pendelleuchte'], stehlampe: ['stehlampe', 'stehleuchte'], stehleuchte: ['stehleuchte', 'stehlampe'], tischlampe: ['tischlampe'], tischleuchte: ['tischlampe'], nachttischlampe: ['tischlampe'], wandlampe: ['wandleuchte'],
    teppich: ['teppich'], teppiche: ['teppich'], laeufer: ['laeufer', 'teppich'], spiegel: ['spiegel'], wandspiegel: ['spiegel'], vase: ['vase'], vasen: ['vase'], kerze: ['kerze', 'kerzenhalter'], kerzen: ['kerze', 'kerzenhalter'], kerzenstaender: ['kerzenhalter'],
    bild: ['poster', 'bild', 'wandbild'], bilder: ['poster', 'wandbild'], poster: ['poster'], wanddeko: ['poster', 'wandbild', 'spiegel'], deko: ['deko', 'vase', 'kerzenhalter'], dekoration: ['deko', 'vase'],
    pflanze: ['kunstpflanze', 'pflanze'], kunstpflanze: ['kunstpflanze'], blumentopf: ['blumentopf', 'uebertopf'], uebertopf: ['blumentopf'], geschirr: ['geschirr', 'teller', 'schale'], tasse: ['becher', 'tasse'], tassen: ['becher', 'tasse'], becher: ['becher'],
    garten: ['garten', 'gartenlounge', 'gartenstuhl', 'gartentisch'], gartenmoebel: ['garten', 'gartenlounge', 'gartenmoebel'], outdoor: ['garten', 'outdoor'], terrasse: ['garten', 'lounge'], balkon: ['garten', 'balkon'],
    lounge: ['lounge', 'gartenlounge'], gartenlounge: ['gartenlounge', 'lounge'], loungemoebel: ['gartenlounge', 'lounge'], gartenstuhl: ['gartenstuhl'], gartenstuehle: ['gartenstuhl'], gartentisch: ['gartentisch', 'garten', 'esstisch'],
    sonnenschirm: ['sonnenschirm', 'sonnnenschirm'], schirm: ['sonnenschirm', 'sonnnenschirm'], haengematte: ['haengematte'], feuerstelle: ['feuerstelle', 'feuerschale'], feuerschale: ['feuerstelle'],
    kinder: ['kinder'], kinderzimmer: ['kinder'], minecraft: ['minecraft'],
    leder: ['leder', 'echtleder', 'kunstleder'], echtleder: ['echtleder', 'leder'], kunstleder: ['kunstleder'], lederoptik: ['kunstleder'], samt: ['samt'], velvet: ['samt'], velours: ['samt', 'velours'],
    cord: ['cord'], cordstoff: ['cord'], kord: ['cord'], teddy: ['teddy', 'boucle'], chenille: ['chenille'], leinen: ['leinen', 'stoff'], stoff: ['stoff', 'strukturstoff'], webstoff: ['stoff', 'strukturstoff'],
    holz: ['holz', 'eiche', 'massiv', 'holzbett'], eiche: ['eiche', 'holz'], massiv: ['massiv', 'holz'], massivholz: ['massiv', 'holz'], metall: ['metall'], marmor: ['marmor'], glas: ['glas'], rattan: ['rattan'],
    led: ['led'], beleuchtung: ['led', 'leuchte'], usb: ['usb'],
    weiss: ['weiss'], creme: ['beige', 'creme'], anthrazit: ['anthrazit', 'grau'], hellgrau: ['hellgrau', 'grau'], dunkelgrau: ['dunkelgrau', 'grau', 'anthrazit'], cognac: ['cognac', 'braun'], taupe: ['taupe'], sand: ['sand', 'beige'],
    pink: ['rosa', 'rose', 'pink'], rosa: ['rosa', 'rose'], altrosa: ['rose', 'rosa'], navy: ['blau'], tuerkis: ['petrol', 'blau'], mint: ['gruen', 'salbei'], olive: ['olive', 'gruen'], salbei: ['salbei', 'gruen'], senf: ['senf', 'gelb'], gold: ['gold'],
    designer: [], modern: [], moebel: [], luxus: [], guenstig: [], billig: [], angebot: [], sale: [], neu: [], schlafzimmer: [], wohnzimmer: [], zimmer: [], fuer: [], mit: [], ohne: [], aus: [], von: [], zum: [], zur: [], im: [], am: [], und: [], das: [], der: [], die: [], ein: [], eine: [], ich: [], suche: [],
    flur: ['garderobe', 'schuhregal'], badezimmer: ['badematte'], bad: ['badematte'], kueche: ['geschirr', 'barhocker'], buero: ['schreibtisch', 'buerostuhl'],
    bed: ['bett'], beds: ['bett'], chair: ['stuhl', 'sessel'], chairs: ['stuhl'], table: ['tisch'], wardrobe: ['kleiderschrank', 'schrank'], closet: ['kleiderschrank'], lamp: ['lampe', 'leuchte'], rug: ['teppich'], carpet: ['teppich'],
    mirror: ['spiegel'], mattress: ['matratze'], pillow: ['kissen'], cushion: ['zierkissen', 'kissen'], blanket: ['decke'], velvet2: ['samt'], corduroy: ['cord'], leather: ['leder'], wood: ['holz'], armchair: ['sessel'], stool: ['hocker'],
    black: ['schwarz'], white: ['weiss'], grey: ['grau'], gray: ['grau'], green: ['gruen'], blue: ['blau'], brown: ['braun'], red: ['rot'], yellow: ['gelb'], garden: ['garten'], kids: ['kinder']
  };

  var COLORS = [
    { v: 'beige', label: 'Beige', re: /^(beige|sand|creme|cream|natur|ivory|taupe|champagner|elfenbein)/ },
    { v: 'grau', label: 'Grau', re: /^(grau|hellgrau|dunkelgrau|anthrazit|charcoal|silber|graphit)/ },
    { v: 'schwarz', label: 'Schwarz', re: /^(schwarz|black)/ },
    { v: 'weiss', label: 'Weiß', re: /^(weiss|white|ivory)/ },
    { v: 'braun', label: 'Braun', re: /^(braun|cognac|dunkelbraun|burnt|raw|mokka|schoko|walnuss|nuss)/ },
    { v: 'gruen', label: 'Grün', re: /^(gruen|olive|salbei|verdigris|mint|green|tanne)/ },
    { v: 'blau', label: 'Blau', re: /^(blau|vintage blau|petrol|navy|prussian|azur|tuerkis)/ },
    { v: 'rose', label: 'Rosé', re: /^(rose|rosa|pink|blush|mauve|altrosa)/ },
    { v: 'rot', label: 'Rot', re: /^(rot|bordeaux|terrakotta|weinrot|red)/ },
    { v: 'gelb', label: 'Gelb', re: /^(gelb|senf|safran|amber|ocker|orange|curry)/ },
    { v: 'lila', label: 'Lila', re: /^(lila|violett|flieder|purple)/ },
    { v: 'bunt', label: 'Bunt', re: /^(bunt|multicolor)/ }
  ];
  var COLOR_WORDS = { beige: 'beige', sand: 'beige', creme: 'beige', natur: 'beige', taupe: 'beige', grau: 'grau', hellgrau: 'grau', dunkelgrau: 'grau', anthrazit: 'grau', silber: 'grau', schwarz: 'schwarz', weiss: 'weiss', braun: 'braun', cognac: 'braun', dunkelbraun: 'braun', gruen: 'gruen', olive: 'gruen', salbei: 'gruen', mint: 'gruen', blau: 'blau', petrol: 'blau', navy: 'blau', tuerkis: 'blau', hellblau: 'blau', dunkelblau: 'blau', rose: 'rose', rosa: 'rose', pink: 'rose', altrosa: 'rose', rot: 'rot', bordeaux: 'rot', terrakotta: 'rot', weinrot: 'rot', gelb: 'gelb', senf: 'gelb', orange: 'gelb', lila: 'lila', violett: 'lila', bunt: 'bunt' };

  var FABRICS = { samt: /samt|velvet|velour/, boucle: /boucl|teddy|sherpa|lammfell/, teddy: /teddy|boucl/, cord: /cord|corduroy/, chenille: /chenille/, leder: /leder|leather/, echtleder: /echtleder/, kunstleder: /kunstleder|lederoptik/, stoff: /stoff|leinen|linen|webstoff|strukturstoff/, leinen: /leinen|linen/ };

  // Kategorie-Wörter → Produktkategorie (custom.kategorie) / Gruppe; und die passende Kategorieseite für den Chip
  var CATS = [
    { re: /^boxspringbett(en)?$/, label: 'Boxspringbetten', url: '/collections/boxspringbetten', cat: /^(elektrisches )?boxspringbett/ },
    { re: /^polsterbett(en)?$/, label: 'Polsterbetten', url: '/collections/polsterbetten', cat: /^polsterbett/ },
    { re: /^holzbett(en)?$/, label: 'Holzbetten', url: '/collections/holzbetten', cat: /^holzbett/ },
    { re: /^kinderbett(en)?$/, label: 'Kinderbetten', url: '/collections/kinderbetten', cat: /kinderbett|hochbett/ },
    { re: /^bett(en)?$/, label: 'Betten', url: '/collections/betten', group: 'betten' },
    { re: /^ecksofa(s)?$/, label: 'Ecksofas', url: '/collections/sofas', cat: /^sofa/, title: /ecksofa/ },
    { re: /^sofa(s)?$/, label: 'Sofas', url: '/collections/sofas', cat: /^sofa$/ },
    { re: /^sessel$/, label: 'Sessel', url: '/collections/sessel', cat: /sessel/ },
    { re: /^(relaxliege|liege|sonnenliege)(n)?$/, label: 'Liegen', url: '/collections/relaxliegen', cat: /liege/ },
    { re: /^matratze(n)?$/, label: 'Matratzen', url: '/collections/nightsense™matratzen', cat: /^matratze/ },
    { re: /^topper$/, label: 'Topper', url: '/collections/nightsense™-topper', cat: /^topper/ },
    { re: /^lattenrost(e)?$/, label: 'Lattenroste', url: '/collections/lattenroste', cat: /^lattenrost/ },
    { re: /^(zierkissen|kissen)$/, label: 'Kissen', url: '/collections/zierkissen', cat: /kissen/ },
    { re: /^(tagesdecke|bettdecke|decke)(n)?$/, label: 'Decken', url: '/collections/tagesdecken', cat: /decke/ },
    { re: /^bettwaesche$/, label: 'Bettwäsche', url: '/collections/bettwaesche', cat: /bettwaesche/ },
    { re: /^couchtisch(e)?$/, label: 'Couchtische', url: '/collections/couchtische', cat: /^couchtisch/ },
    { re: /^beistelltisch(e)?$/, label: 'Beistelltische', url: '/collections/beistelltische', cat: /^beistelltisch/ },
    { re: /^esstisch(e)?$/, label: 'Esstische', url: '/collections/esstische', cat: /^esstisch/ },
    { re: /^nachttisch(e)?$/, label: 'Nachttische', url: '/collections/nachttische', cat: /^nachttisch/ },
    { re: /^schreibtisch(e)?$/, label: 'Schreibtische', url: '/collections/schreibtische', cat: /^schreibtisch/ },
    { re: /^(stuhl|stuehle|esszimmerstuhl|esszimmerstuehle)$/, label: 'Stühle', url: '/collections/stuehle', cat: /stuhl|stuehle/ },
    { re: /^barhocker$/, label: 'Barhocker', url: '/collections/barhocker', cat: /barhocker|thekenhocker/ },
    { re: /^(hocker|pouf)(s)?$/, label: 'Hocker & Poufs', url: '/collections/beistellhocker', cat: /hocker|pouf/ },
    { re: /^(kleiderschrank|schrank|schraenke|kleiderschraenke)$/, label: 'Schränke', url: '/collections/kleiderschranke', cat: /schrank|schraenke/ },
    { re: /^kommode(n)?$/, label: 'Kommoden', url: '/collections/kommoden', cat: /^kommode/ },
    { re: /^(lowboard|tv)(s)?$/, label: 'TV-Lowboards', url: '/collections/lowboard', cat: /lowboard/ },
    { re: /^(regal|wandregal)(e)?$/, label: 'Regale', url: '/collections/regal', cat: /regal/ },
    { re: /^(garderobe|wandgarderobe)(n)?$/, label: 'Garderoben', url: '/collections/garderoben', cat: /garderobe/ },
    { re: /^(pendelleuchte|deckenleuchte)(n)?$/, label: 'Pendelleuchten', url: '/collections/pendelleuchten', cat: /pendelleuchte|deckenleuchte/ },
    { re: /^(tischlampe|tischleuchte)(n)?$/, label: 'Tischlampen', url: '/collections/tischlampen', cat: /tischlampe/ },
    { re: /^(stehlampe|stehleuchte)(n)?$/, label: 'Stehlampen', url: '/collections/stehleuchten', cat: /stehlampe|stehleuchte/ },
    { re: /^wandleuchte(n)?$/, label: 'Wandleuchten', url: '/collections/wandleuchten', cat: /wandleuchte/ },
    { re: /^(lampe|leuchte)(n)?$/, label: 'Lampen', url: '/collections/lampen', cat: /lampe|leuchte/ },
    { re: /^teppich(e)?$/, label: 'Teppiche', url: '/collections/teppiche', cat: /teppich|rechteckig|rund/ },
    { re: /^spiegel$/, label: 'Spiegel', url: '/collections/spiegel', cat: /^spiegel/ },
    { re: /^vase(n)?$/, label: 'Vasen', url: '/collections/vasen', cat: /^vase/ },
    { re: /^(kerze|kerzen|kerzenhalter)$/, label: 'Kerzenhalter', url: '/collections/kerzenhalter', cat: /kerze/ },
    { re: /^poster$/, label: 'Poster', url: '/collections/poster', cat: /^poster/ },
    { re: /^kunstpflanze(n)?$/, label: 'Kunstpflanzen', url: '/collections/kunstpflanzen', cat: /kunstpflanze/ },
    { re: /^(blumentopf|blumentoepfe)$/, label: 'Blumentöpfe', url: '/collections/blumentopfe', cat: /blumentopf/ },
    { re: /^geschirr$/, label: 'Geschirr', url: '/collections/geschirr-besteck-glaser', cat: /geschirr|becher|teller|schale|krug/ },
    { re: /^gartenlounge(s)?$/, label: 'Gartenlounges', url: '/collections/gartenlounges', cat: /gartenlounge/ },
    { re: /^(gartenstuhl|gartenstuehle)$/, label: 'Gartenstühle', url: '/collections/gartenstuhle', cat: /gartenstuhl/ },
    { re: /^gartentisch(e)?$/, label: 'Gartentische', url: '/collections/gartentische', cat: /gartentisch|garten esstisch/ },
    { re: /^(garten|gartenmoebel|outdoor)$/, label: 'Garten', url: '/collections/garten-1', group: 'garten' },
    { re: /^kinder$/, label: 'Kinder', url: '/collections/alles-fur-kinder', group: 'kinder' },
    { re: /^hundebett(en)?$/, label: 'Hundebetten', url: '/search?q=hundebett&type=product', cat: /^hundebett/ }
  ];

  // ---------- Index ----------
  var state = { products: null, vocab: null, loading: null, url: null, extraSyn: {} };

  function buildVocab(products) {
    var counts = {};
    function add(t) { counts[t] = (counts[t] || 0) + 1; }
    products.forEach(function (p) {
      p._tt = tokens(p.t); p._ct = tokens(p.c || ''); p._ft = fold(p.f || ''); p._colf = (p.col || []).map(fold);
      p._szf = (p.sz || []).map(function (s) { return fold(s).replace(/\s/g, ''); });
      p._tt.forEach(add); p._ct.forEach(add);
    });
    Object.keys(SYNONYMS).forEach(function (k) { counts[k] = counts[k] || 1; SYNONYMS[k].forEach(function (a) { counts[a] = counts[a] || 1; }); });
    Object.keys(COLOR_WORDS).forEach(function (k) { counts[k] = counts[k] || 1; });
    return counts;
  }

  function load(url) {
    if (state.products) return Promise.resolve(state.products);
    if (state.loading) return state.loading;
    state.loading = fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('index ' + r.status); return r.json(); }).then(function (d) {
      state.products = d.products || [];
      state.vocab = buildVocab(state.products);
      return state.products;
    }).catch(function (e) { state.loading = null; throw e; });
    return state.loading;
  }

  // ---------- Verstehen ----------
  function correct(tok) {
    var vocab = state.vocab;
    if (!vocab) return null;
    var own = vocab[tok] || 0;
    if (own >= 3 || SYNONYMS[tok] || COLOR_WORDS[tok] || state.extraSyn[tok]) return null;
    if (/^\d/.test(tok) || tok.length < 4) return null;
    var max = tok.length <= 5 ? 1 : 2, best = null, bestScore = -1;
    for (var w in vocab) {
      if (vocab[w] < 2 || vocab[w] < own * 3 || Math.abs(w.length - tok.length) > max || /^\d/.test(w)) continue;
      var d = dist(tok, w, max);
      if (d <= max) {
        var score = (max - d + 1) * 1000 + Math.min(vocab[w], 500) + (w[0] === tok[0] ? 200 : 0);
        if (score > bestScore) { bestScore = score; best = w; }
      }
    }
    return best;
  }
  // Beugungsendungen (schwarzes, graue, runder) auf den Wortstamm, wenn der Stamm deutlich häufiger ist
  function stem(tok) {
    var vocab = state.vocab; if (!vocab || tok.length < 5 || /^\d/.test(tok) || COLOR_WORDS[tok]) return null;
    var ends = ['es', 'er', 'en', 'em', 'e', 's', 'n'], i, e, st;
    // Farbadjektive immer auf die Farbe (schwarzes → schwarz), auch wenn das gebeugte Wort in Titeln vorkommt
    for (i = 0; i < ends.length; i++) {
      e = ends[i];
      if (tok.length - e.length >= 3 && tok.slice(-e.length) === e && COLOR_WORDS[tok.slice(0, -e.length)]) return tok.slice(0, -e.length);
    }
    if (SYNONYMS[tok] || state.extraSyn[tok] || (vocab[tok] || 0) >= 3) return null;
    for (i = 0; i < ends.length; i++) {
      e = ends[i];
      if (tok.length - e.length < 3 || tok.slice(-e.length) !== e) continue;
      st = tok.slice(0, -e.length);
      if (SYNONYMS[st] || (vocab[st] >= 3 && vocab[st] > (vocab[tok] || 0) * 2)) return st;
    }
    return null;
  }
  function splitCompound(tok) {
    var vocab = state.vocab; if (!vocab || tok.length < 7) return null;
    for (var i = 4; i <= tok.length - 3; i++) {
      var a = tok.slice(0, i), b = tok.slice(i);
      if ((vocab[a] >= 3 || SYNONYMS[a]) && (vocab[b] >= 3 || SYNONYMS[b])) return [a, b];
    }
    return null;
  }
  function expand(tok) {
    var out = [tok];
    var syn = state.extraSyn[tok] || SYNONYMS[tok];
    if (syn) out = out.concat(syn);
    return uniq(out);
  }

  function understand(query) {
    var raw = tokens(query), terms = [], corrected = [], notes = [], intents = { colors: [], sizes: [], fabrics: [], cats: [] };
    raw.forEach(function (tok) {
      var size = /^(\d{2,3})x(\d{2,3})$/.exec(tok);
      if (size) { intents.sizes.push(tok); terms.push({ raw: tok, alts: [tok], kind: 'size' }); return; }
      if (/^\d+$/.test(tok)) { if (tok.length >= 2 && tok.length <= 3) intents.sizes.push(tok); terms.push({ raw: tok, alts: [tok], kind: 'num', optional: true }); return; }
      var fixed = correct(tok), used = tok;
      if (fixed && fixed !== tok) { used = fixed; corrected.push([tok, fixed]); }
      else { var st = stem(tok); if (st) used = st; }
      var parts = (state.vocab && state.vocab[used] >= 2) || SYNONYMS[used] || state.extraSyn[used] ? null : splitCompound(used);
      var words = parts || [used];
      words.forEach(function (w) {
        var alts = expand(w);
        if (COLOR_WORDS[w] && alts.length <= 3) { intents.colors.push(COLOR_WORDS[w]); terms.push({ raw: w, alts: alts, kind: 'color' }); return; }
        if (FABRICS[w]) { intents.fabrics.push(w); terms.push({ raw: w, alts: alts, kind: 'fabric' }); return; }
        var cat = null;
        for (var ai = 0; ai < alts.length && !cat; ai++) for (var i = 0; i < CATS.length; i++) if (CATS[i].re.test(alts[ai])) { cat = CATS[i]; break; }
        if (cat) intents.cats.push(cat);
        terms.push({ raw: w, alts: alts, kind: cat ? 'cat' : 'word', optional: SYNONYMS[w] && SYNONYMS[w].length === 0 });
      });
    });
    return { raw: raw, terms: terms.filter(function (t) { return !t.optional || t.kind === 'num'; }), corrected: corrected, intents: intents, notes: notes };
  }

  // ---------- Suchen & Bewerten ----------
  function termScore(p, term) {
    var best = 0, sum = 0, i, j, alt, tt = p._tt;
    for (i = 0; i < term.alts.length; i++) {
      alt = term.alts[i];
      var altBest = 0;
      if (term.kind === 'size') {
        if (p._szf.some(function (s) { return s.indexOf(alt) === 0; })) return 9;
        continue;
      }
      if (term.kind === 'num') { if (p._szf.some(function (s) { return s.indexOf(alt + 'x') === 0; }) || tt.indexOf(alt) >= 0) return 5; continue; }
      if (term.kind === 'color') {
        var c = COLORS.filter(function (x) { return x.v === COLOR_WORDS[term.raw]; })[0];
        if (c && p._colf.some(function (cf) { return c.re.test(cf); })) best = Math.max(best, 8);
        if (tt.indexOf(alt) >= 0) best = Math.max(best, 6);
        continue;
      }
      if (term.kind === 'fabric') {
        if (FABRICS[alt] && (FABRICS[alt].test(p._ft) || FABRICS[alt].test(p._tt.join(' ')))) best = Math.max(best, 8);
        continue;
      }
      var w = i === 0 ? 1 : 0.85;
      for (j = 0; j < tt.length; j++) {
        var t = tt[j];
        if (t === alt) { altBest = Math.max(altBest, (i === 0 ? 12 : 10) * w); break; }
        if (alt.length >= 4 && t.indexOf(alt) === 0) altBest = Math.max(altBest, 7 * w);
        else if (alt.length >= 4 && t.length > alt.length && t.indexOf(alt) > 0) altBest = Math.max(altBest, 5 * w);
      }
      if (p._ct.indexOf(alt) >= 0) altBest = Math.max(altBest, 9 * w);
      else if (alt.length >= 4 && p._ct.some(function (c) { return c.indexOf(alt) >= 0; })) altBest = Math.max(altBest, 6 * w);
      if (alt.length >= 4 && p._ft.indexOf(alt) >= 0) altBest = Math.max(altBest, 7 * w);
      sum += altBest; if (altBest > best) best = altBest;
    }
    // Synonymgruppe: bester Treffer zählt voll, weitere Treffer der Gruppe ein Drittel (Sofa + Schlaffunktion > nur Sofa)
    return best + (sum - best) * 0.35;
  }

  function scoreAll(u) {
    var required = u.terms.filter(function (t) { return t.kind !== 'num'; });
    var results = [];
    state.products.forEach(function (p) {
      var score = 0, matched = 0, catHit = false, fits = true, i;
      for (i = 0; i < u.terms.length; i++) {
        var s = termScore(p, u.terms[i]);
        if (s > 0) { matched++; score += s; if (u.terms[i].kind === 'cat') catHit = true; }
      }
      if (!matched) return;
      var need = required.length <= 1 ? 1 : Math.ceil(required.length * 0.6);
      if (matched < need) return;
      // Kategorie-Absicht: Produkt aus der gemeinten Kategorie bevorzugen, andere stark abwerten
      if (u.intents.cats.length) {
        fits = u.intents.cats.some(function (c) {
          var cf = fold(p.c || '');
          if (c.group) return p.g.indexOf(c.group) >= 0;
          if (c.cat && c.cat.test(cf) && (!c.title || c.title.test(p._tt.join(' ')))) return true;
          return false;
        });
        if (fits) score += 6; else if (catHit) score -= 2; else score -= 6;
      }
      // Farbe gewünscht, aber nicht vorhanden → raus
      if (u.intents.colors.length) {
        var hasColor = u.intents.colors.some(function (cv) { var c = COLORS.filter(function (x) { return x.v === cv; })[0]; return c && p._colf.some(function (cf) { return c.re.test(cf); }); });
        if (!hasColor) return;
      }
      if (u.intents.sizes.length && p._szf.length) {
        var hasSize = u.intents.sizes.some(function (sz) { return p._szf.some(function (s) { return s.indexOf(sz) === 0 || s.indexOf(sz + 'x') === 0; }); });
        if (!hasSize) return;
      }
      score += Math.min(p.s || 0, 60) / 12 + (p.r ? (p.r - 4) * 1.5 : 0);
      results.push({ p: p, score: score, matched: matched, fits: fits, sold: p.s || 0 });
    });
    return results;
  }

  // Reihenfolge: erst die Produkte, die alle Suchbegriffe treffen und zur gemeinten Kategorie passen,
  // innerhalb dieser Stufe immer nach Bestseller (Verkäufe der letzten 30 Tage), dann erst nach Textnähe.
  function byBestseller(a, b) {
    return b.matched - a.matched || (b.fits ? 1 : 0) - (a.fits ? 1 : 0) || b.sold - a.sold || b.score - a.score;
  }

  function search(query, limit) {
    var u = understand(query);
    if (!u.terms.length || !state.products) return { understood: u, results: [], total: 0 };
    var required = u.terms.filter(function (t) { return t.kind !== 'num'; });
    var results = scoreAll(u);
    results.sort(byBestseller);
    var relaxed = false;
    if (results.length < 3 && required.length > 1) {
      // Nichts Genaues: nur die Kategorie-Absicht (bzw. das stärkste Wort) behalten
      var keep = u.terms.filter(function (t) { return t.kind === 'cat' || t.kind === 'color' || t.kind === 'size'; });
      if (!keep.length) keep = [u.terms[0]];
      var u2 = { raw: u.raw, terms: keep, corrected: u.corrected, intents: u.intents, notes: u.notes };
      var again = scoreAll(u2);
      if (again.length > results.length) { results = again.sort(byBestseller); relaxed = true; }
    }
    return { understood: u, results: results.slice(0, limit || 24), total: results.length, relaxed: relaxed };
  }

  function colorImage(p, intents) {
    if (!p.ci || !intents.colors.length) return null;
    for (var i = 0; i < intents.colors.length; i++) {
      var c = COLORS.filter(function (x) { return x.v === intents.colors[i]; })[0];
      if (!c) continue;
      var keys = Object.keys(p.ci).filter(function (k) { return c.re.test(fold(k)); });
      if (keys.length) return { file: p.ci[keys[0]], name: keys[0] };
    }
    return null;
  }

  function chips(res, max) {
    var counts = {}, order = [];
    res.results.forEach(function (r) {
      var p = r.p, cf = fold(p.c || ''), hit = null;
      for (var i = 0; i < CATS.length; i++) { var c = CATS[i]; if (c.group ? false : (c.cat && c.cat.test(cf) && (!c.title || c.title.test(p._tt.join(' '))))) { hit = c; break; } }
      r.cat = hit ? hit.label : '';
      if (!hit) return;
      if (!counts[hit.label]) { counts[hit.label] = { label: hit.label, url: hit.url, n: 0 }; order.push(hit.label); }
      counts[hit.label].n++;
    });
    return order.map(function (k) { return counts[k]; }).sort(function (a, b) { return b.n - a.n; }).slice(0, max || 4);
  }

  // ---------- Darstellung ----------
  function card(r, intents, big) {
    var p = r.p, ci = colorImage(p, intents);
    var file = ci ? ci.file : p.i, img = imgUrl(file, big ? 600 : 400);
    var price = p.p != null ? 'ab ' + money(p.p) : '';
    return '<a class="cxs__card" href="/products/' + esc(p.h) + '">' +
      '<span class="cxs__media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>' +
      '<span class="cxs__body"><span class="cxs__title">' + esc(p.t) + (ci ? ' <em>in ' + esc(ci.name) + '</em>' : '') + '</span>' +
      (price ? '<span class="cxs__price">' + esc(price) + '</span>' : '') + '</span></a>';
  }
  function describe(u) {
    var parts = [];
    u.corrected.forEach(function (c) { parts.push('„' + esc(c[0]) + '“ → „' + esc(c[1]) + '“'); });
    return parts;
  }
  function render(root, query, res, opts) {
    var u = res.understood, html = '';
    if (!res.results.length) {
      html = '<div class="cxs__empty"><b>Dazu haben wir nichts gefunden.</b><span>Versuch es mit einem anderen Begriff – z. B. „Boxspringbett 180x200“, „Ecksofa Cord“ oder „Couchtisch“.</span></div>';
      root.innerHTML = html; root.hidden = false; return;
    }
    var corr = describe(u);
    var head = '<div class="cxs__head">';
    if (corr.length) head += '<p class="cxs__hint">Wir haben korrigiert: ' + corr.join(', ') + '</p>';
    else if (res.relaxed) head += '<p class="cxs__hint">Nichts Genaues zu „' + esc(query) + '“ – das kommt dem am nächsten:</p>';
    head += '<p class="cxs__count">' + res.total + ' passende Produkte' + (opts.page ? ' für „' + esc(query) + '“' : '') + '</p></div>';
    var ch = chips(res);
    var chipHtml = ch.length ? '<div class="cxs__chips">' + ch.map(function (c) { return '<a class="cxs__chip" href="' + esc(c.url) + '">' + esc(c.label) + ' <b>' + c.n + '</b></a>'; }).join('') + '</div>' : '';
    var n = opts.limit || 6;
    var grid = '<div class="cxs__grid">' + res.results.slice(0, n).map(function (r) { return card(r, u.intents, false); }).join('') + '</div>';
    var foot = '';
    if (!opts.page) {
      var q = u.corrected.length ? u.raw.map(function (t) { var c = u.corrected.filter(function (x) { return x[0] === t; })[0]; return c ? c[1] : t; }).join(' ') : query;
      foot = '<div class="cxs__foot"><a class="cxs__all" href="/search?q=' + encodeURIComponent(q) + '&type=product' + (q !== query ? '&cxq=' + encodeURIComponent(query) : '') + '">Alle ' + res.total + ' Treffer ansehen<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true"><path d="M647-440H200q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520h447L451-716q-12-12-11.5-28t12.5-28q12-11 28-11.5t28 11.5l264 264q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L508-188q-11 11-27.5 11T452-188q-12-12-12-28.5t12-28.5l195-195Z"/></svg></a></div>';
    }
    root.innerHTML = head + chipHtml + grid + foot;
    root.hidden = false;
  }

  function parseExtraSyn(text) {
    var map = {};
    String(text || '').split(/[\n,;]+/).forEach(function (line) {
      var m = /^\s*([^=]+?)\s*=\s*(.+?)\s*$/.exec(line); if (!m) return;
      var key = fold(m[1]).replace(/\s+/g, ''), vals = m[2].split(/[|\/+ ]+/).map(fold).filter(Boolean);
      if (key && vals.length) map[key] = vals;
    });
    return map;
  }

  // ---------- Such-Schublade ----------
  function initDrawer(box) {
    var form = box.closest('form'), input = form && form.elements['q'], url = box.getAttribute('data-cxs-index');
    if (!form || !input || !url) return;
    state.extraSyn = parseExtraSyn(box.getAttribute('data-cxs-synonyms'));
    var predictive = form.querySelector('predictive-search'), timer = null, last = '';
    function setMode(active) {
      box.hidden = !active;
      if (predictive) predictive.toggleAttribute('data-cxs-hidden', active);
    }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { setMode(false); last = ''; return; }
      if (q === last) return;
      last = q;
      if (!state.products) {
        box.innerHTML = '<div class="cxs__loading"><span></span><span></span><span></span></div>'; setMode(true);
        load(url).then(function () { if (input.value.trim() === q) { last = ''; run(); } }).catch(function () { setMode(false); });
        return;
      }
      render(box, q, search(q, 24), { limit: 6 });
      setMode(true);
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 160); });
    input.addEventListener('focus', function () { load(url).catch(function () {}); });
    form.addEventListener('reset', function () { setTimeout(function () { setMode(false); last = ''; }, 0); });
    // Beim Absenden die korrigierte Schreibweise mitgeben, damit Shopifys Ergebnisseite passt
    form.addEventListener('submit', function () {
      if (!state.products) return;
      var u = understand(input.value);
      if (!u.corrected.length) return;
      var fixed = u.raw.map(function (t) { var c = u.corrected.filter(function (x) { return x[0] === t; })[0]; return c ? c[1] : t; }).join(' ');
      var hid = form.querySelector('input[name="cxq"]');
      if (!hid) { hid = document.createElement('input'); hid.type = 'hidden'; hid.name = 'cxq'; form.appendChild(hid); }
      hid.value = input.value; input.value = fixed;
    });
    // Falls die Schublade mit Text geöffnet wird
    if (input.value.trim().length >= 2) run();
  }

  // ---------- Ergebnisseite ----------
  // Eigene Seite statt Shopifys „1002 Treffer“: Überschrift = Suchanfrage, echte Trefferzahl, Kategorie-Chips als Filter,
  // alle Treffer nach Bestseller sortiert, 24 auf einmal mit „Mehr anzeigen“. Shopifys Raster wird nur ausgeblendet,
  // wenn wir genug gefunden haben (sonst bleibt es als Ergänzung sichtbar).
  var PAGE_STEP = 24;
  function renderPage(box, q, original, res) {
    var u = res.understood, all = res.results, cats = chips(res, 8), filter = '', shown = PAGE_STEP;
    var section = box.closest('.shopify-section');
    var titleEl = section && section.querySelector('.page-spacer > .v-stack > h1, .empty-state > h1');
    var corr = describe(u);
    var sub = res.total + ' passende Produkte';
    if (corr.length) sub += ' · korrigiert: ' + corr.join(', ');
    else if (original && original !== q) sub += ' · gesucht: „' + esc(original) + '“';
    else if (res.relaxed) sub += ' · nichts Genaues gefunden, das kommt dem am nächsten';
    var head = '<div class="cxsp__head"><p class="cxsp__kicker">Suchergebnis</p><h1 class="cxsp__title">' + esc(q) + '</h1><p class="cxsp__sub">' + sub + '</p></div>';
    if (titleEl) { titleEl.hidden = true; titleEl.insertAdjacentHTML('afterend', head); }
    else box.insertAdjacentHTML('beforebegin', head);
    if (section && res.total >= 4) section.classList.add('cxs-page-active');

    function visible() { return filter ? all.filter(function (r) { return r.cat === filter; }) : all; }
    function draw() {
      var list = visible(), html = '';
      if (cats.length > 1) {
        html += '<div class="cxs__chips cxsp__chips" role="group" aria-label="Kategorie">' +
          '<button type="button" class="cxs__chip' + (filter ? '' : ' is-active') + '" data-cxs-chip="">Alle <b>' + all.length + '</b></button>' +
          cats.map(function (c) { return '<button type="button" class="cxs__chip' + (filter === c.label ? ' is-active' : '') + '" data-cxs-chip="' + esc(c.label) + '">' + esc(c.label) + ' <b>' + c.n + '</b></button>'; }).join('') +
          '<span class="cxsp__sort">Beliebteste zuerst</span></div>';
      } else {
        html += '<div class="cxsp__chips cxsp__chips--sort"><span class="cxsp__sort">Beliebteste zuerst</span></div>';
      }
      html += '<div class="cxs__grid cxsp__grid">' + list.slice(0, shown).map(function (r) { return card(r, u.intents, true); }).join('') + '</div>';
      if (list.length > shown) html += '<div class="cxsp__more"><button type="button" class="cxsp__more-btn" data-cxs-more>Mehr anzeigen <span>(' + (list.length - shown) + ' weitere)</span></button></div>';
      box.innerHTML = html; box.hidden = false;
    }
    box.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-cxs-chip]'), more = e.target.closest('[data-cxs-more]');
      if (chip) { filter = chip.getAttribute('data-cxs-chip'); shown = PAGE_STEP; draw(); }
      else if (more) { shown += PAGE_STEP; draw(); }
    });
    draw();
  }
  function initPage(box) {
    var url = box.getAttribute('data-cxs-index'), q = (new URLSearchParams(location.search).get('q') || '').trim();
    var original = (new URLSearchParams(location.search).get('cxq') || '').trim();
    if (!url || !q) return;
    state.extraSyn = parseExtraSyn(box.getAttribute('data-cxs-synonyms'));
    load(url).then(function () {
      var res = search(q, 5000);
      if (!res.results.length) { box.hidden = true; return; }
      renderPage(box, q, original, res);
    }).catch(function () { box.hidden = true; });
  }

  function init() {
    document.querySelectorAll('[data-cxs]').forEach(function (b) { if (!b.dataset.ready) { b.dataset.ready = '1'; initDrawer(b); } });
    document.querySelectorAll('[data-cxs-page]').forEach(function (b) { if (!b.dataset.ready) { b.dataset.ready = '1'; initPage(b); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.CXSearch = { search: search, understand: understand, load: load, state: state };
})();
